import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit
} from "@angular/core";
import {
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared.module";
import { PaymentStatusEnum } from "src/app/enums/payment-status.enum";
import { IPayment, IReservationData, PaymentConditionItem } from "src/app/services/model/get-trip-data.model";
import { StateService } from "src/app/services/state.service";

@Component({
  selector: "app-price-container",
  templateUrl: "./price-container.component.html",
  styleUrls: ["./price-container.component.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, SharedModule],

})
export class PriceContainerComponent implements OnInit {

  @Input() isReturn: boolean = false;

  @Input() tripData: IReservationData;

  readonly stateService = inject(StateService);

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
  }

  get amountToDisplay(): number {
    if (!this.isReturn) {
      return this.tripData?.remainingToPay ?? 0;
    }

    return this.tripData?.totalPaid ?? 0;
  }

  get remainingToPay(): number {
    if (!this.isReturn) {
      return 0;
    }

    const remainingToPay = this.tripData?.remainingToPay ?? 0;

    return remainingToPay > 0 ? -remainingToPay : Math.abs(remainingToPay);
  }

  get remainingToPayLabelKey(): string {
    return (this.tripData?.remainingToPay ?? 0) > 0
      ? "webPos.Underpayment"
      : "webPos.RemainingToReturn";
  }

  public getStatusClass(status: PaymentStatusEnum) {
    return PaymentStatusEnum[status]?.toLowerCase() || status?.toString() || '';
  }
}